<template>
    <div :class="classList">
        <transition name="scroll-y-transition" mode="out-in">
            <slot v-if="isEditable && editing" name="active" v-bind="{ editing, errors }" />
            <button v-if="!editing" type="button" class="app-field__button" @click="onShowActive">
                <slot v-if="findSlot('default')" />
                <span v-else>{{ label || $t('empty') }}</span>
            </button>
        </transition>
    </div>
</template>

<script>
import wait from '@/lib/helpers/wait';
import getInput from '@/lib/helpers/getInput';

export default {
    name: 'AppField',
    props: {
        label: {
            type: String,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        editable: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        editing: false,
        errors: null
    }),
    computed: {
        isEditable() {
            return this.findSlot('active') || this.editable;
        },
        classList() {
            let classList = ['app-field'];

            if (this.isEditable) {
                classList.push('app-field--editable');
            }

            if (this.disabled) {
                classList.push('app-field--disabled');
            }

            if (this.errors) {
                classList.push('app-field--error');
            }

            return classList.join(' ');
        }
    },
    methods: {
        async onShowActive() {
            if (this.disabled) {
                return;
            }
            this.$emit('active');
            this.editing = true;
            this.errors = null;
            this.focus();
        },
        async focus() {
            await wait(500);
            const input = getInput(this.$el);
            if (input) input.focus();
        }
    }
};
</script>

<style lang="scss">
.app-field {
    &--editable {
        .app-field__button {
            cursor: pointer;
        }
    }

    &--disabled {
        .app-field__button {
            cursor: default;
        }
    }

    &__button {
        min-height: 2.8rem;
        padding: 0 0.8rem;
        border-radius: 4px;
        transition: background 0.15s ease-in-out;
        color: rgba(0, 0, 0, 0.7);
        cursor: default;
        width: 100%;
        text-align: left;
        // background: var(--v-background-darken1);
        &:is(.app-field--editable .app-field__button):not(.app-field--disabled .app-field__button):hover {
            background: var(--v-background-darken2);
        }
    }
}
</style>
